import { constantRoutes, systemRoutes } from '@/router'

// 菜单已硬编码在前端。constantRoutes 包含 Layout 框架路由及首页；
// systemRoutes 为各业务页面的一级菜单路由。
//
// 注意：addRoutes 初始为空数组，确保路由守卫首次进入时会执行
// router.addRoute('Root', ...) 将系统路由注册到 Vue Router。
// 侧边栏始终直接使用 systemRoutes（无需等待动态挂载）。

const state = {
  routes: [...constantRoutes, ...systemRoutes],
  addRoutes: []
}

const mutations = {
  SET_ROUTES(state, routes) {
    state.addRoutes = routes
    state.routes = [...constantRoutes, ...routes]
  }
}

const actions = {}

export default { namespaced: true, state, mutations, actions }
